import _ from 'lodash'
import React from 'react'

import { EntityTableWithGroupSimplification } from 'browser/components/atomic-elements/organisms/entity/entity-table-with-group-simplification'
// tslint:disable-next-line:max-line-length
import { DocumentsTableActionBar } from 'browser/components/atomic-elements/organisms/table-action-bar/documents-table-action-bar'

/**
 * Entity table to render rows of document entities
 *
 * @props IEntityTableProps
 */
export class DocumentTable extends EntityTableWithGroupSimplification {
  render() {
    const { selection } = this.props
    return (
      <EntityTableWithGroupSimplification {...this.props}>
        <DocumentsTableActionBar
          entityPath='data'
          selection={selection}
          actions={this.props.actions}
        />
      </EntityTableWithGroupSimplification>
    )
  }
}
